import { Box } from '@mui/material';
import { styled } from '@mui/system';

export const AttachmentsPreviewListWrapper = styled(Box)({
	'& .str-chat__attachment-list-scroll-container': {
		display: 'flex',
		alignItems: 'center',
		gap: '10px',
	},

	'& .str-chat__attachment-preview-thumbnail.str-chat__base-image': {
		width: '100px',
		height: '100px',
	},

	'.ck-body-wrapper': {
		zIndex: '2000',
	},
});
